import SlickSlider from './SlickSlider';

export default SlickSlider;
